import { DataGridBodySkeletonLoader } from '../../common/DataGrid';

export function AppsTableLoadingState() {
  return (
    <DataGridBodySkeletonLoader
      columns={5}
      rows={5}
      widthRanges={[
        [70, 100],
        [120, 120],
        [30, 30],
        [50, 50],
        [20, 20],
      ]}
      textAlign={['left', 'left', 'left', 'center', 'center']}
    />
  );
}
